var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"tab2"}},[_c('h1',[_vm._v("Tab 2")]),_c('p',[_vm._v("Example tab menu 2 case is disabled.")])])
}]

export { render, staticRenderFns }